import Vue from 'vue'
import { Plugin } from 'vue-responsive-video-background-player'

Vue.use(Plugin);
